import React from 'react';
import moment from 'moment';

class DayWithWeek extends React.Component {

  render() {
    const {date} = this.props;
    const monthDay = moment(date).format("D");
    const weekName = moment(date).format("ddd");

    return (
      <div>
        <div>{weekName}</div>
        <div>{monthDay}</div>
      </div>
    )
  }
}

export default DayWithWeek;



// WEBPACK FOOTER //
// ./src/components/common/format/DayWithWeek.js